// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lora', 'Lora Fallback'","fontWeight":500,"fontStyle":"italic"},"className":"__className_76c157","variable":"__variable_76c157"};